import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	FormGroup,
	Label,
	Row,
	Col,
	Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import {  getRFQWithoutPOList } from "../../../store/Quotation/actions";
import {
	getRFQToPOPendingReportreportslist,
	RFQToPOPendingReportslistSuccessful,
	reportTypeCheck,
	SetParams,
	ReportsChangeValue,
	ReportsSelecteChangeValue,
	getRFQVendors,
} from "../../../store/Reports/actions";

// const mrStatus = [
//   { value: "0", label: "All" },
//   { value: "1,2", label: "Pedning" },
//   { value: "3", label: "HOD(U) Approved" },
//   { value: "4", label: "HOD(U) Rejected" },
//   { value: "5", label: "HOD(M) Approved" },
//   { value: "6", label: "HOD(M) Rejected" },

// ];
var date = new Date(),
	y = date.getFullYear(),
	m = date.getMonth();
class RFQToPPReports extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.ReportsChangeHandeler = this.ReportsChangeHandeler.bind(this);
	}

	componentDidMount() {
		// Fetch RFQ vendors from the API
		this.props.getRFQVendors({
			page: 1,
			page_size: 10,
		});
		this.props.getRFQWithoutPOList();
		this.props.SetParams({});
	}
	ReportsChangeHandeler(e) {
		this.props.ReportsChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
		if (this.props.reportType === "document") {
			this.props.getRFQToPOPendingReportreportslist({
				...this.props.params,
				[e.target.name]: e.target.value,
			});
		}
	}
	SelecteChangeValue({ key, label, key2, value }) {
		console.log('SelecteChangeValue called:', { key, label, key2, value });
		this.props.ReportsSelecteChangeValue({
			key,
			label,
			key2,
			value,
		});
		if (this.props.reportType === "document") {
			this.props.getRFQToPOPendingReportreportslist({
				...this.props.params,
				[key2]: value,
			});
		}
		if (key2 === 'requestforquotation') {
			console.log('Fetching vendors for RFQ:', value, 'with page_size: 100');
			this.props.getRFQVendors({
				page: 1,
				page_size: 100,
				rfq_id: value
			});
		}
	}
	reportType(e) {
		this.props.reportTypeCheck({ value: e.target.value });

		this.props.RFQToPOPendingReportslistSuccessful([]);
		if (e.target.value === "document") {
			this.props.getRFQToPOPendingReportreportslist({
				...this.props.params,
				start_date:
					this.props.params.start_date == null ||
					this.props.params.start_date === ""
						? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
						: this.props.params.start_date,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? moment(new Date()).format("YYYY-MM-DD")
						: this.props.params.end_date,
			});
		}
	}
	reportCheck(e) {
		this.props.ReportsChangeValue({
			key: "action",
			value: e.target.value,
		});
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom ">
										<Link
											to="/reports"
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<h5 className="card-title-18 pt-2 d-inline-block">
											RFQ to PO Pending Report
										</h5>
									</CardHeader>
									<CardBody className="pt-1">
										<Row className="p-1">
											<Col md={12}>
												<Card className="p-1">
													<CardBody className="pt-1">
														<Row>
															<Col
																md={3}
																className="mb-0">
																<FormGroup className="mb-0 pb-0">
																	<Label
																		htmlFor="validationFromDate"
																		className="col-form-label">
																		From
																		Date:
																	</Label>

																	<Input
																		className="mb-0 form-control "
																		type="date"
																		value={
																			this
																				.props
																				.params
																				.start_date ==
																				null ||
																			this
																				.props
																				.params
																				.start_date ===
																				""
																				? moment(
																						new Date(
																							y,
																							m,
																							1
																						)
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																				: this
																						.props
																						.params
																						.start_date
																		}
																		onChange={(
																			e
																		) => {
																			this.ReportsChangeHandeler(
																				e
																			);
																		}}
																		id="CProduct-Name-text-input"
																		name="start_date"
																		placeholder="select Date"
																		max={moment(
																			new Date()
																		).format(
																			"YYYY-MM-DD"
																		)}
																	/>
																</FormGroup>
															</Col>
															<Col
																md={3}
																className="mb-0">
																<FormGroup className="mb-0 pb-0">
																	<Label
																		htmlFor="validationToDate"
																		className="mb-0 col-form-label">
																		To Date:
																	</Label>

																	<Input
																		className="mb-0 form-control "
																		type="date"
																		value={
																			this
																				.props
																				.params
																				.end_date ==
																				null ||
																			this
																				.props
																				.params
																				.end_date ===
																				""
																				? moment(
																						new Date()
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																				: this
																						.props
																						.params
																						.end_date
																		}
																		onChange={(
																			e
																		) => {
																			this.ReportsChangeHandeler(
																				e
																			);
																		}}
																		id="CProduct-Name-text-input"
																		name="end_date"
																		placeholder="select Date"
																		disabled={
																			this
																				.props
																				.params
																				.start_date ===
																			""
																				? true
																				: false
																		}
																		min={
																			this
																				.props
																				.params
																				.start_date ==
																				null ||
																			this
																				.props
																				.params
																				.start_date ===
																				""
																				? moment(
																						new Date(
																							y,
																							m,
																							1
																						)
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																				: moment(
																						this
																							.props
																							.params
																							.start_date
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																		}
																		max={moment(
																			new Date()
																		).format(
																			"YYYY-MM-DD"
																		)}
																	/>
																</FormGroup>
															</Col>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="Location-selection"
																		className="col-form-label">
																		Request
																		For
																		Quotation
																		:
																	</Label>

																	<Select
																		id="Department-selection"
																		name="Department-selection"
																		classNamePrefix="select2-selection"
																		menuPortalTarget={
																			document.body
																		}
																		styles={{
																			menuPortal:
																				(
																					base
																				) => ({
																					...base,
																					zIndex: 9999,
																				}),
																		}}
																		options={(this.props.rfqWithoutPOList || []).map(
																			(
																				item,
																				index
																			) => ({
																				label: item.code,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.Reportdata
																				?.requestforquotationlabel,
																			value: this
																				.props
																				.params
																				?.requestforquotation,
																		}}
																		onChange={(
																			e
																		) => {
																			this.SelecteChangeValue(
																				{
																					key: "requestforquotationlabel",
																					label: e.label,
																					key2: "requestforquotation",
																					value: e.value,
																				}
																			);
																		}}
																	/>
																</FormGroup>
															</Col>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="vendorslist-selection"
																		className="col-form-label">
																		Vendors
																		List :
																	</Label>

																	<Select
																		id="vendorslist-selection"
																		name="vendorslist-selection"
																		classNamePrefix="select2-selection"
																		menuPortalTarget={
																			document.body
																		}
																		styles={{
																			menuPortal:
																				(
																					base
																				) => ({
																					...base,
																					zIndex: 9999,
																				}),
																		}}
																	options={(this.props.rfqVendors || []).map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.Reportdata
																				?.vendorlabel,
																			value: this
																				.props
																				.params
																				?.vendor,
																		}}
																		onChange={(
																			e
																		) => {
																			this.SelecteChangeValue(
																				{
																					key: "vendorlabel",
																					label: e.label,
																					key2: "vendor",
																					value: e.value,
																				}
																			);
																		}}
																		loading={
																			this
																				.props
																					.rfqVendorsLoading
																		}
																		onInputChange={(
																			inputValue,
																			{
																				action,
																			}
																		) => {
																			if (
																				action ===
																				"input-change"
																			) {
																				console.log('Vendor search with page_size: 100, search:', inputValue, 'rfq_id:', this.props.params?.requestforquotation);
																				this.props.getRFQVendors(
																					{
																						...this
																							.props
																							.rfqVendorsParams,
																						page: 1,
																						page_size: 100,
																						search: inputValue,
																					}
																				);
																			}
																		}}
																		onMenuOpen={() => {
																			console.log('Vendor menu opened, fetching with page_size: 100, rfq_id:', this.props.params?.requestforquotation);
																			this.props.getRFQVendors(
																				{
																					...this
																						.props
																						.rfqVendorsParams,
																					page: 1,
																					page_size: 100,
																					search: "",
																				}
																			);
																		}}
																		// onMenuClose={() => {
																		// 	this.props.clearMiniVendors();
																		// }}
																		onMenuScrollToBottom={() => {
																			console.log('Scroll to bottom - Current page:', this.props.rfqVendorsParams.page, 'Total pages:', this.props.rfqVendorsParams.no_of_pages);
																			if (
																				this
																					.props
																					.rfqVendorsParams
																					.page <
																				this
																					.props
																					.rfqVendorsParams
																					.no_of_pages
																			) {
																				console.log('Fetching next page:', this.props.rfqVendorsParams.page + 1);
																				this.props.getRFQVendors(
																					{
																						...this
																							.props
																							.rfqVendorsParams,
																						page:
																							this
																								.props
																								.rfqVendorsParams
																								.page +
																							1,
																						page_size: 100,
																					}
																				);
																			}
																		}}
																	/>
																</FormGroup>
															</Col>
															<Col
																md={3}
																className="mt-1 text-center font-size-14">
																<div className="mb-1">
																	<Label>
																		&nbsp;
																	</Label>
																</div>
																<div className="border p-2">
																	<div className="radio d-inline-block mr-5">
																		<Input
																			type="radio"
																			value="list"
																			name="reportType"
																			checked={
																				// true
																				this
																					.props
																					.reportType ===
																				"list"
																					? true
																					: false
																			}
														onClick={(
														e
													) =>
														this.reportType(
														e
													)
													}
														onChange={(e) => this.reportType(e)}
																		/>
																		List
																	</div>
																	
																</div>
															</Col>
														
														</Row>

														<Row>
															<Col
																md={12}
																className="mt-1">
																<div className="float-right pt-1">
																	{this.props
																		.reportType ===
																		"document" && (
																		<Link
																			to={
																				"/rfqtopopendingreportdoc/" +
																				this
																					.props
																					.params
																					.QId
																			}>
																			<Button
																				block
																				type="button"
																				color="primary"
																				disabled={
																					this
																						.props
																						.params
																						.QId ==
																						null ||
																					this
																						.props
																						.params
																						.QId ===
																						""
																						? true
																						: false
																				}
																				className="waves-effect waves-light">
																				Generate
																				Report
																			</Button>
																		</Link>
																	)}

																	{this.props
																		.reportType ===
																		"list" && (
																		<Link to="/rfqtopopendingreportlist">
																			<Button
																				block
																				type="button"
																				color="primary"
																				className="waves-effect waves-light">
																				Generate
																				Report
																			</Button>
																		</Link>
																	)}
																</div>
															</Col>
														</Row>
														{/* </div> */}
													</CardBody>
												</Card>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { rfqVendors, rfqVendorsLoading, rfqVendorsParams } = state.reports;
	const { rfqWithoutPOList } = state.Quotation;
	const { params, reportType, Reportdata } = state.reports;
	return {
		rfqVendors,
		rfqVendorsLoading,
		rfqVendorsParams,
		reportType,
		params,
		Reportdata,
		rfqWithoutPOList,
		//-------
	};
};

export default connect(mapStatetoProps, {
	getRFQVendors,
	getRFQToPOPendingReportreportslist,
	reportTypeCheck,
	SetParams,
	ReportsChangeValue,
	ReportsSelecteChangeValue,
	RFQToPOPendingReportslistSuccessful,
	getRFQWithoutPOList,
})(RFQToPPReports);
